import { Flex } from '@bookjane2/bookjane-design-library';
import styled, { css } from 'styled-components';
import { BKJSSFBarSearchInputVariant } from 'components/BKJSSFBarSearchInput/BKJSSFBarSearchInput';

export const BKJSSFBarSearchInputWrapper = styled.label<{ variant?: BKJSSFBarSearchInputVariant }>`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: relative;
  order: 101;
  padding: 0 12px;

  ${({ variant = 'page' }) => {
    switch (variant) {
      case 'modal':
        return css`
          height: 36px;
          min-height: 36px;
          max-height: 36px;
          min-width: 100%;
          width: 100%;
          max-width: 100%;
          @media (max-width: ${({ theme }) => theme.breakpoints.Mobile}) {
            height: 46px;
            min-height: 46px;
          }
        `;
      case 'page':
      default:
        return css`
          height: 52px;
          min-height: 52px;
          max-height: 52px;
          min-width: 150px;
          width: 320px;
          max-width: 320px;
          @media (max-width: ${({ theme }) => theme.breakpoints.Mobile}) {
            height: 36px;
            min-height: 36px;
          }
        `;
    }
  }}
`;

export const StyledBKJSSFBarSearchInput = styled.input<{ variant?: BKJSSFBarSearchInputVariant }>`
  ${({ theme }) => theme.fonts.PoppinsTextMedium};
  ${({ theme }) => theme.common.Ellipsis};
  background-color: ${({ theme }) => theme.colors.White};
  color: ${({ theme }) => theme.colors.TextSubtleGrey};
  align-items: center;
  border: none;
  display: flex;
  height: 100%;
  line-height: 24px;
  outline: none;
  width: 100%;
  padding: 0;
  &::placeholder {
    color: ${({ theme }) => theme.colors.Grey4};
  }

  ${({ variant = 'page' }) => {
    switch (variant) {
      case 'modal':
        return css`
          font-size: 14px;
        `;
      case 'page':
      default:
        return css`
          font-size: 16px;
        `;
    }
  }}
`;

export const IconWrapper = styled(Flex)<{ variant?: BKJSSFBarSearchInputVariant }>`
  width: 24px;
  min-width: 24px;
  box-sizing: content-box;
  justify-content: center;
  align-items: center;

  ${({ variant = 'page' }) => {
    switch (variant) {
      case 'modal':
        return css`
          height: 40px;

          @media (max-width: ${({ theme }) => theme.breakpoints.Mobile}) {
            height: 36px;
          }
        `;
      case 'page':
      default:
        return css`
          height: 52px;

          @media (max-width: ${({ theme }) => theme.breakpoints.Mobile}) {
            height: 48px;
          }
        `;
    }
  }}
`;
